const HEADER_CONSTANT = {
  HEADER_LOGO: 'HEADER LOGO',
  MENU_LINK: 'MENU LINK',
  DEALS_LINK: 'DEALS LINK',
  CATERING_LINK: 'CATERING LINK',
  SIGN_IN_LINK: 'SIGN IN LINK',
  CART_ICON: 'CART ICON',
  LANGUAGE_SELECTOR: 'LANGUAGE SELECTOR',
  SUPPORT_LINK: 'SUPPORT SECTION',
  GUEST_USER_SINGIN_TEXT: 'signInSignUp',
  LOGGEDIN_USER_SINGIN_TEXT: 'account',
  CART_ICON_100_PERCENT: 'CART ICON ANIMATION_100%',
  CART_ICON_120_PERCENT: 'CART ICON ANIMATION_120%',
  BACK_TO_CART: 'backToCart',
  USER_SINGIN_TEXT: 'Sign In',
  Go_TO_HOME_PAGE: 'GoToHomePage',
  ZERO: 0,
  CART_ALT_TEXT: 'Cart',
};
export default HEADER_CONSTANT;
